import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { toggleTheme } from "./toggleTheme";
export var LabelText = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    // Ensure proper alignment, especially when labelPlacement=\"start\"\n    flex-grow: 1;\n    // Add small margin to center-align first line of text with toggle.\n    margin-top: ", ";\n\n    ", "\n\n    ", "\n"])), function (_ref) {
  var size = _ref.size,
    themeMode = _ref.themeMode;
  return toggleTheme.labelMarginTop[size](themeMode);
}, function (_ref2) {
  var placement = _ref2.placement,
    themeMode = _ref2.themeMode;
  switch (placement) {
    case "start":
      return "margin-right: ".concat(toggleTheme.labelGap(themeMode), ";");
    case "end":
    default:
      return "margin-left: ".concat(toggleTheme.labelGap(themeMode), ";");
  }
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  if (isDisabled) {
    return "opacity: 0.4;";
  }
});
//# sourceMappingURL=LabelText.js.map